/**
 * Checks if ther are pending async requests.
 * @param {number} requestCount
 * @returns {boolean}
 */
export const isPending = (requestCount: number): boolean => requestCount > 0;

/**
 * Splits the name passed on its last underscore.
 * @param {string} name
 * @returns {string[]}
 */
export const splitOnLastUnderscore = (name: string): string[] => {
  const lastUnderscore: number = name.lastIndexOf('_');

  if (lastUnderscore === -1) {
    return ['', name];
  }

  return [name.substr(0, lastUnderscore), name.substr(lastUnderscore)];
};

/**
 * Creates a custom delayed promise.
 * @function delay
 * @param {number} milliseconds
 * @returns {Promise}
 */
export const delay = (milliseconds: number): Promise<void> => new Promise<void>(resolve => {
  setTimeout(resolve, milliseconds);
});
